import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Component, OnInit, Inject } from '@angular/core';


@Component({
  selector: 'app-usersSiteTransactionModal',
  templateUrl: '../templates/transactionModal.component.html'
})
export class TransactionModalComponent implements OnInit {
  details: string;

  constructor(private dialogRef: MatDialogRef<TransactionModalComponent>, @Inject(MAT_DIALOG_DATA)
  private data: { detailsJson: string }) {
    try {
      this.details = JSON.stringify(JSON.parse(data.detailsJson), null, 2);
    } catch (ex) {
      console.log(ex);
      this.details = data.detailsJson;
    }
  }

  ngOnInit() {

  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/scripts/transactionModal.component.ts